export default __webpack_public_path__ + "static/media/cosmetic0.8e004dc9.JPG";